import React from 'react';
import { useRouter } from 'next/router';
import Head from 'next/head';

const Index: React.FC = () => {
  const { replace } = useRouter();

  React.useEffect(() => {
    replace('/app/projects');
  });

  return (
    <Head>
      <meta name="robots" content="noindex, nofollow" />
    </Head>
  );
};

export default Index;
